// extracted by mini-css-extract-plugin
export default {"btnContainer":"SendTranspareonAccountRequest_btnContainer__kvM5S"};